import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { Badge, Dropdown, Spinner, Table } from 'react-bootstrap';

// import images
import verticalicon from '../.././../images/verticalicon-dots.svg';
import { API_BASE_URL, formatDate, formatDateAndTime, getBearerToken, pickTimeWithAMPM, setLoadingState } from '../../../functions';
import axios from 'axios';
import { useAuth } from '../auth/AuthProvider';
import toast from 'react-hot-toast';
import ConfirmationPopup from '../../Modals/ConfirmationPopup';
import UmrahTimeUpdate from '../../Modals/UmrahTimeUpdate';
import UmrahConfirmBooking from '../../Modals/UmrahConfirmBooking';
import UmrahUpdatePNR from '../../Modals/UmrahUpdatePNR';
import UmrahAdditionalDiscount from '../../Modals/UmrahAdditionalDiscount';
import CountdownTimer from '../../CountdownTimer';

const UmrahBookingsTRLoop = ({ data = [] }) => {
    const [showTime, setShowTime] = useState(false);
    const [showConfirm, setShowConfirm] = useState(false);
    const [showPNR, setShowPNR] = useState(false);
    const [showDiscount, setShowDiscount] = useState(false);
    const { token } = useAuth();
    const [targetBooking, setTargetBooking] = useState('');
    const [confirmation, setConfirmation] = useState({ show: false, target: '' });
    const [isLoading, setIsLoading] = useState(false);

    const handleTimeUpdate = (booking) => {
        setTargetBooking(booking);
        setShowTime(true);
    };

    const handleConfirm = (booking) => {
        setTargetBooking(booking);
        setShowConfirm(true);
    };

    const handleCancel = (booking) => {
        setConfirmation({ show: true, target: 'cancel' });
        setTargetBooking(booking);
    };

    const handlePNRUpdate = (booking) => {
        setTargetBooking(booking);
        setShowPNR(true);
    };

    const handleDiscount = (booking) => {
        setTargetBooking(booking);
        setShowDiscount(true);
    };

    const handleConfirmAction = (e) => {
        e.preventDefault();
        setConfirmation({ show: false, target: '' });
        setIsLoading(true);
        const tid = toast.loading("Please wait...");
        
        axios.get(`${API_BASE_URL}/umrah-booking/cancel/${targetBooking.id}`, {
            headers: {
                'Authorization': `Bearer ${getBearerToken()}`
            }
        }).then(response => {
            toast.success('Umrah booking cancelled successfully!');
            toast.dismiss(tid);
            setIsLoading(false);
            setTimeout(() => {
                window.location.reload();
            }, 2000);
        }).catch(error => {
            toast.error(error.response?.data?.message || 'Failed to cancel booking');
            toast.dismiss(tid);
            setIsLoading(false);
        });
    };

    return (
        <>
            <Table responsive="sm" className="mb-0 allView">
                <thead className="thead-dark">
                    <tr>
                        <th>Id</th>
                        <th>PNR</th>
                        <th>Package</th>
                        <th>Room Type</th>
                        <th>Travel Date</th>
                        {token.role === 'admin' && <th>Pay. Status</th>}
                        {token.role === 'admin' && <th>Agent</th>}
                        <th>Booking Date</th>
                        <th>Status</th>
                        <th></th>
                    </tr>
                </thead>
                <tbody>
                    {data?.map((booking, index) => (
                        <tr key={booking.id}>
                            <td>
                                <Link to={`/dashboard/umrah-book/${booking.id}`} className="text-decoration-none bluetext fontweight600">
                                    {booking.id} - view booking
                                </Link>
                            </td>
                            <td>
                                {token.role === 'admin' ? (
                                    <Link to={`/dashboard/umrah-pnr/${booking.pnr}`} className="text-decoration-none bluetext fontweight600">
                                        {booking.pnr || 'N/A'}
                                    </Link>
                                ) : (
                                    <>{booking.pnr || 'N/A'}</>
                                )}
                            </td>
                            <td>
                                <div className="d-flex align-items-center">
                                    <div>
                                        <div className="fontweight600">{booking.umrah_package?.title}</div>
                                        <small className="text-muted">
                                            {booking.umrah_package?.departure_flights && booking.umrah_package.departure_flights.length > 0 && (
                                                <>
                                                    <i className="fas fa-plane-departure text-info me-1"></i>
                                                    {booking.umrah_package.departure_flights[0].departure_airport} → {booking.umrah_package.departure_flights[booking.umrah_package.departure_flights.length - 1].arrival_airport}
                                                    <br />
                                                </>
                                            )}
                                            {booking.umrah_package?.return_flights && booking.umrah_package.return_flights.length > 0 && (
                                                <>
                                                    <i className="fas fa-plane-arrival text-success me-1"></i>
                                                    {booking.umrah_package.return_flights[0].departure_airport} → {booking.umrah_package.return_flights[booking.umrah_package.return_flights.length - 1].arrival_airport}
                                                </>
                                            )}
                                        </small>
                                    </div>
                                </div>
                            </td>
                            <td>
                                <div className="d-flex flex-column">
                                    <Badge bg="info" className="text-capitalize mb-1">
                                        {booking.room_type}
                                    </Badge>
                                    <small className="text-muted">
                                        <i className="fas fa-bed me-1"></i>
                                        {booking.room_quantity} {booking.room_quantity === 1 ? 'Room' : 'Rooms'}
                                    </small>
                                </div>
                            </td>
                            <td>
                                <div className="d-flex flex-column">
                                    {booking.umrah_package?.departure_flights && booking.umrah_package.departure_flights.length > 0 && (
                                        <span className="fontsize12">
                                            <i className="fas fa-plane-departure text-info me-1"></i>
                                            {formatDate(booking.umrah_package.departure_flights[0].departure_date)}
                                        </span>
                                    )}
                                    {booking.umrah_package?.return_flights && booking.umrah_package.return_flights.length > 0 && (
                                        <span className="fontsize12">
                                            <i className="fas fa-plane-arrival text-success me-1"></i>
                                            {formatDate(booking.umrah_package.return_flights[0].arrival_date)}
                                        </span>
                                    )}
                                </div>
                            </td>
                            {token.role === 'admin' && (
                                <td>
                                    <Badge
                                        bg=""
                                        className={`p-2 py-1 ${booking.payment_status == '2' ? 'successcolorbg whitetext' : booking.payment_status == '1' ? 'warninglighterbg yellowtext' : booking.payment_status == '0' && 'errorlighterbg redtext'}`}
                                    >
                                        {booking.payment_status == '2' ? 'Paid' : booking.payment_status == '1' ? 'Partial' : booking.payment_status == '0' && 'Unpaid'}
                                    </Badge>
                                </td>
                            )}
                            {token.role === 'admin' && <td>{booking?.user?.name || 'N/A'}</td>}
                            <td>{booking.created_at ? formatDate(booking.created_at) : 'N/A'}</td>
                            <td>
                                <div className="d-grid text-center">
                                    <Badge
                                        bg=""
                                        className={`p-2 py-1 ${(booking.confirmed == 1 && booking.cancel_status == 0) ? 'successcolorbg whitetext' :
                                            (booking.confirmed == 0 && booking.cancel_status == 0) ? 'warninglighterbg yellowtext' :
                                                booking.cancel_status == 1 && 'errorlighterbg redtext'}`}
                                    >
                                        {booking.cancel_status == 1 ? 'Cancelled' :
                                            booking.confirmed == 1 ? 'Confirmed' :
                                                booking.confirmed == 0 && 'Hold'}
                                    </Badge>
                                    {(booking.cancel_status != 1 && booking?.hold_expires_at && booking?.confirmed != 1) ? (
                                        <div className="d-flex flex-column">
                                            <CountdownTimer 
                                                expiryTime={booking.hold_expires_at}
                                                onExpire={() => {
                                                    // Show a toast notification instead of reloading
                                                    toast.error('Booking has expired and will be cancelled automatically');
                                                }}
                                            />
                                            <small className="text-muted fontsize10">
                                                Exp. {booking?.hold_expires_at ? formatDate(booking.hold_expires_at) : 'N/A'} at {booking?.hold_expires_at ? pickTimeWithAMPM(booking.hold_expires_at) : 'N/A'}
                                            </small>
                                        </div>
                                    ) : null}
                                </div>
                            </td>
                            <td>
                                <Dropdown className="" align="end" autoClose="outside">
                                    <Dropdown.Toggle className="p-2" variant="" id="dropdown-autoclose-outside">
                                        <img className="img-fluid" src={verticalicon} alt="icon" />
                                    </Dropdown.Toggle>
                                    <Dropdown.Menu>
                                        <Link to={`/dashboard/umrah-book/${booking?.id}`} className="dropdown-item">
                                            View
                                        </Link>
                                        {token.role === 'admin' ? (
                                            <>
                                                {booking?.confirmed == 0 && booking?.cancel_status == 0 ? (
                                                    <Link to="#" className="dropdown-item" onClick={() => handleTimeUpdate(booking)}>
                                                        Extend H.Time
                                                    </Link>
                                                ) : null}
                                                <Link to="#" className="dropdown-item" onClick={() => handleCancel(booking)}>
                                                    {isLoading ? (
                                                        <Spinner as="span" animation="border" size="sm" role="status" aria-hidden="true" />
                                                    ) : (
                                                        'Cancel Booking'
                                                    )}
                                                </Link>
                                                {booking?.confirmed != 1 && (
                                                    <Link to="#" className="dropdown-item" onClick={() => handleConfirm(booking)}>
                                                        Confirm Booking
                                                    </Link>
                                                )}
                                                <Link to="#" className="dropdown-item" onClick={() => handlePNRUpdate(booking)}>
                                                    {booking.pnr ? 'Update PNR' : 'Add PNR'}
                                                </Link>
                                                <Link to="#" className="dropdown-item" onClick={() => handleDiscount(booking)}>
                                                    {booking.additional_discount_amount > 0 ? 'Edit Discount' : 'Add Discount'}
                                                </Link>
                                                <Link to={`/dashboard/umrah-pnr/${booking.pnr}`} className="dropdown-item">
                                                    Open full PNR
                                                </Link>
                                            </>
                                        ) : (
                                            <>
                                                {booking?.confirmed !== '1' && booking?.cancel_status !== '1' && (
                                                    <Link to="#" className="dropdown-item" onClick={() => handleCancel(booking)}>
                                                        {isLoading ? (
                                                            <Spinner as="span" animation="border" size="sm" role="status" aria-hidden="true" />
                                                        ) : (
                                                            'Cancel Booking'
                                                        )}
                                                    </Link>
                                                )}
                                            </>
                                        )}
                                    </Dropdown.Menu>
                                </Dropdown>
                            </td>
                        </tr>
                    ))}
                </tbody>
            </Table>
            
            {showTime && token.role === 'admin' && (
                <UmrahTimeUpdate show={showTime} setShow={setShowTime} selectedBooking={targetBooking} />
            )}
            
            {showConfirm && token.role === 'admin' && (
                <UmrahConfirmBooking show={showConfirm} setShow={setShowConfirm} selectedBooking={targetBooking} />
            )}
            
            {showPNR && token.role === 'admin' && (
                <UmrahUpdatePNR show={showPNR} setShow={setShowPNR} selectedBooking={targetBooking} />
            )}
            
            {showDiscount && token.role === 'admin' && (
                <UmrahAdditionalDiscount 
                    show={showDiscount} 
                    setShow={setShowDiscount} 
                    selectedBooking={targetBooking}
                    onSuccess={() => window.location.reload()}
                />
            )}
            
            {confirmation.target === 'cancel' && (
                <ConfirmationPopup 
                    show={confirmation} 
                    setShow={setConfirmation} 
                    handleConfirm={handleConfirmAction}
                    message="Are you sure you want to cancel this Umrah booking?"
                />
            )}
        </>
    );
};

export default UmrahBookingsTRLoop;